import { render, staticRenderFns } from "./CompareLoansDetailComplete.vue?vue&type=template&id=23fbe733&scoped=true&"
import script from "./CompareLoansDetailComplete.vue?vue&type=script&lang=js&"
export * from "./CompareLoansDetailComplete.vue?vue&type=script&lang=js&"
import style0 from "./CompareLoansDetailComplete.vue?vue&type=style&index=0&id=23fbe733&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fbe733",
  null
  
)

export default component.exports